/**
 * Shared form data for the Early Access submission
 */
export interface EarlyAccessFormData {
    firstName: string;
    lastName: string;
    email: string;
    studio: string;
    role: string;
    platforms: string[];
}

/**
 * Defines PublicApi State interface
 */
export interface PublicApiState {
    httpInProgress: boolean;
    httpError: string;
    submitted: boolean;
}

/**
 * Defines PublicApi action names
 */
export const PUBLIC_API_EA_IN_PROGRESS = 'PUBLIC_API_EA_IN_PROGRESS'
export const PUBLIC_API_EA_SUCCESS     = 'PUBLIC_API_EA_SUCCESS'
export const PUBLIC_API_EA_ERROR       = 'PUBLIC_API_EA_ERROR'

/**
 * Defines PublicApi action interfaces
 */
interface PublicApiEAInProgressAction { type: typeof PUBLIC_API_EA_IN_PROGRESS; }
interface PublicApiEASuccessAction    { type: typeof PUBLIC_API_EA_SUCCESS; }
interface PublicApiEAErrorAction      { type: typeof PUBLIC_API_EA_ERROR; error: string; }

/**
 * Defines all supported actions for PublicApi
 */
export type PublicApiActionTypes =
    PublicApiEAInProgressAction |
    PublicApiEASuccessAction |
    PublicApiEAErrorAction;

/**
 * Defines PublicApiActionsInterface
 */
export interface PublicApiActionsInterface {
    earlyAccessSubmit: (form: EarlyAccessFormData) => Promise<void>;
}
